<template>
  <div class="col-lg-3 col-md-3 col-6">
    <div class="item-prd">
        <div class="img-prd">
            <router-link
                exact
                :to="{
                  name: 'productDetail',
                  params: { slug: product.seoName }
                  }"
            >
                <img v-bind:src="getImages(product)" v-bind:title="product.name" />
            </router-link>
        </div>
        <h2 class="name-prd">
            <router-link
                exact
                :to="{
                    name: 'productDetail',
                    params: { slug: product.seoName }
                    }"
            >{{product.name}}
            </router-link>
        </h2>
        <div class="price-box clearfix">			
            <span class="product-price" v-if="product.price > 0" >
            	{{ product.price | currency}}
          		<del class="product-price-old">{{ product.oldPrice | currency}}</del>
            </span>
            <span v-else ><router-link exact :to="{  name: 'contact',  params: { slug: 'lien-he' }}">Giá: Liên hệ</router-link></span>                                       
            
        </div>                                    
    </div>
</div>
</template>
<script>
import util from "@/common/util";
export default {
  name: "RwvProductItem",
  props: {
    product: { type: Object, required: true },
    currentIndex: { type: Number, required: true }
  },
  methods: {
    getImages(data) {
      return util.getImages(data.image);
    }
  }
};
</script>
<style>
.clear {
  clear: both;
}
</style>
